import CollectionRequirements from './CollectionRequirements';

export default CollectionRequirements;
